import AvatarCommon from './containers/avatarCommon'

export {default as AvatarCommonLayout} from './components/avatarCommonLayout'

export default AvatarCommon
